import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

import { Stack, Typography } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './Status.module.scss';
import { Icon } from '@/components/ui/Icon';
import { uiIcons } from '@/constants/uiIcons';

interface StatusProps extends ComponentPropsWithoutRef<'div'> {
  type: 'new' | 'beta';
}

export const Status = forwardRef<HTMLDivElement, StatusProps>(
  ({ type, className, ...props }, ref) => {
    const { t } = useTranslation('navigation');

    return (
      <Stack
        ref={ref}
        className={cx(styles.Status, className, {
          [styles.StatusNew]: type === 'new',
          [styles.StatusBeta]: type === 'beta',
        })}
        direction="row"
        alignItems="center"
        gap={0}
        {...props}
      >
        {type === 'new' && <Icon name={uiIcons.release.new} />}
        <Typography variant="label" component="span">
          {/* No need to translate "Beta", note that languages with long translations for "New" just got the untranslated English label*/}
          {`${(type === 'new' ? t('itemStatus.New') : 'Beta').toUpperCase()}`}
        </Typography>
      </Stack>
    );
  },
);

Status.displayName = 'Status';
